import { type CarrierDef } from '../common.js'
import { type DocumentType } from '../document-types.js'
import { accountNumber, password, username, userPassMap } from '../internal.js'

const credentialTypes = [
  username,
  password,
  'client-id',
  'client-secret',
] as const
const locationCredentialTypes = [accountNumber] as const

export type dayrCredType =
  | (typeof credentialTypes)[number]
  | (typeof locationCredentialTypes)[number]

export const dayrDocumentTypes = [
  'delivery-photo',
  'invoice',
  'proof-of-delivery',
  'pickup-photo',
  'signed-bol',
] as const satisfies readonly DocumentType[]

export const dayr: CarrierDef<dayrCredType> = {
  name: 'Day & Ross General Freight',
  scac: 'dayr',
  ltlServices: [{ id: 'standard', name: 'Standard' }],
  credentialTypes,
  locationCredentialTypes,
  legacyCredMap: [
    ...userPassMap,
    ['client-id', 'clientId'],
    ['client-secret', 'clientSecret'],
    ['account-number', 'accountNumber'], // engine only
  ],
  engineLayers: ['pickup', 'documents', 'invoice'],
  documentTypes: dayrDocumentTypes,
}
